import { createStore, GenericStoreEnhancer } from 'redux';
import rootReducer from './index';

export default (enhancer: GenericStoreEnhancer) => {
	return createStore(rootReducer, enhancer);
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/store/create.ts